export default __webpack_public_path__ + "static/media/gallery_07.1b342105.jpg";